import script from "./SectionGalerie.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionGalerie.vue?vue&type=script&setup=true&lang=js"

import "./SectionGalerie.vue?vue&type=style&index=0&id=7fedbbfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fedbbfe"]])

export default __exports__